import { CountryCode } from '@carsys/enums/country-code'
import { IWholesalerService, OrderSystem } from '@cbgms/api'
import { MutationOptions, useMutation, useQueryClient } from '@cbgms/base/http/use-query'
import { useDispatch } from 'react-redux'
import { wholesalerOrderSystemKey, wholesalerWithServiceKey } from './cache-keys'
import { toggleWholesalerService } from '../state/actions'

interface InputProps {
  UUID: string
  country: CountryCode
  orderSystem: OrderSystem
  services: IWholesalerService[]
}

export const useMutateWholesalerService = (option?: MutationOptions<void, unknown, InputProps, unknown>) => {
  const queryClient = useQueryClient()
  const dispatch = useDispatch()
  return useMutation(
    async ({ UUID, services, country, orderSystem }) => {
      await Promise.all(
        services.map(item =>
          dispatch(
            toggleWholesalerService(UUID, {
              CountryCode: country,
              OrderSystem: orderSystem,
              Service: item.Service,
              Active: item.Active,
              Config: item.Config
            })
          )
        )
      )
    },
    {
      ...option,
      onSuccess: async (_, inputProps) => {
        await queryClient.invalidateQueries(wholesalerWithServiceKey(inputProps.UUID, inputProps.country, inputProps.orderSystem))
        await queryClient.invalidateQueries(wholesalerOrderSystemKey(inputProps.country, inputProps.orderSystem))
      }
    }
  )
}
